import React from "react";
import Select from 'react-select';

import FilterSearch from "./FilterSearch";
import GlobalContext from "./GlobalContext";

function Filters(){
  const global = React.useContext(GlobalContext);

  //if(Object.keys(global.state.filterCategories).length === 0) return false;

  const themeOverride = theme => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary: '#7D2260',
      primary25: '#BDE6FF'
    }
  });

  const filters = global.state.filterParentCategories.map((parent, index) => {
    const options = global.state.filterCategories[parent].map(category => {
      return {
        value: category.id,
        label: category.name
      }
    });
    return (
      <Select
        isMulti
        placeholder={ `Select a category` }
        name={ `filter-${index}` }
        onChange={ global.actions.changeFilter }
        options={ options }
        className="basic-multi-select"
        classNamePrefix="select"
        theme={ themeOverride }
      />
    );
  })

  return (
    <div className="filters">
      {filters}
      <FilterSearch />
    </div>
  );
}

export default Filters;